import Overview from "./overview";
import Revenue from "./revenue";
import ViewReports from "./view-reports";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { Route as invoicingRoute } from "@/routes/(inventory)/branch/_layout/reports/index";
import { useState } from "react";
import { OverviewReportResponse } from "@/gen/reports/overview_pb";
import { DateRangePicker } from "@/components/ui/date-range-picker";
import { type DateRange } from 'react-day-picker'
import { startOfDay, endOfDay } from 'date-fns'
import { pharmacyClient } from "@/connect";
// import { invoicingRoute } from '.';
const API_URL = import.meta.env.VITE_API_URL as string;

const Component = () => {
  //   const patients = patientRoute.useLoaderData();
  const props = invoicingRoute.useLoaderData();
  const [initialOverviewData, setInitialOverviewData] =
    useState<OverviewReportResponse>(props.overview);


  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: startOfDay(new Date()),
    to: endOfDay(new Date()),
  })
  async function handleDateRangeChange(range: DateRange | undefined) {
    setDateRange(range)
    if (!range?.from || !range?.to) return;

    const startDate = dayjs(range.from).startOf('day').unix();
    const endDate = dayjs(range.to).endOf('day').unix();

    const overviewData = await pharmacyClient.overviewReport({
      startDate: startDate,
      endDate: endDate,
    })
    setInitialOverviewData(overviewData);
  }

  return (
    <>
      <div className="space-y-8 overflow-y-scroll h-screen pb-48">

      <div className="flex flex-col gap-4 justify-between bg-[#f9f9f9] p-4">
        <div className="flex items-center justify-between">
          <h2 className="text-4xl font-bold tracking-tight">
            Reports Overview
          </h2>
          <DateRangePicker
            date={dateRange}
            onDateChange={handleDateRangeChange}
          />
        </div>
        <Overview data={initialOverviewData} />
        <ViewReports />
        </div>
        <Revenue data={props.revenue} />
      </div>
    </>
  );
};

export default Component;
